import { render, staticRenderFns } from "./FacilitiesGroupDetailsDialog.vue?vue&type=template&id=09b1bd28&"
import script from "./FacilitiesGroupDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./FacilitiesGroupDetailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports